import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
  ReactElement,
  CSSProperties,
} from 'react';

import { stopEventEffects } from '~/utils';
import COLORS from '~/constants/colors';

interface TextButtonProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  callback?: (event: Event) => void | Promise<void>;
  loading?: boolean;
  disabled?: boolean;
  style?: CSSProperties;
}

function TextButton({
  callback,
  loading = false,
  disabled = false,
  style,
  children,
  ...props
}: PropsWithChildren<TextButtonProps>): ReactElement {
  // Styling
  const textButtonStyle = {
    color: COLORS.chetwodeBlue,
    cursor: 'pointer',
    ...style,
  };

  // Event handlers
  const handleMouseUp = async (event) => {
    stopEventEffects(event);
    if (!loading && !disabled) await callback?.(event);
  };
  const handleTouchEnd = async (event) => {
    if (callback) stopEventEffects(event);
    if (!loading && !disabled) await callback?.(event);
  };

  return (
    <b
      role="none"
      onMouseUp={handleMouseUp}
      onTouchEnd={handleTouchEnd}
      style={textButtonStyle}
      {...props}
    >
      {children}
    </b>
  );
}

export default TextButton;
